import { colors } from '@lmc/common/constants'
import React, { type ReactElement } from 'react'
import { Icon } from '../../../general/Icon'

export type IconCellProps = {
  cellStyle?: object
  iconColor?: string
  iconName: string
  iconSize?: number
  onSelect?: () => void
}

export default function IconCell({
  cellStyle,
  iconColor = colors.black,
  iconName,
  iconSize = 24,
  onSelect
}: IconCellProps): ReactElement {
  const containerStyle = {
    ...styles.cell,
    ...(!!onSelect && { cursor: 'pointer' }),
    ...cellStyle
  }

  return (
    <div
      onClick={onSelect}
      onKeyPress={onSelect}
      role="link"
      style={containerStyle}
      tabIndex={0}
    >
      <Icon color={iconColor} name={iconName} size={iconSize} />
    </div>
  )
}

const styles = {
  cell: {
    display: 'flex',
    justifyContent: 'center'
  }
}
